import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/shared/infrastructure/auth/token-storage";
import { RegisterPage } from "@/modules/auth/presentation/pages/RegisterPage";

export const Route = createFileRoute("/register")({
  beforeLoad: () => {
    if (getAccessToken()) {
      throw redirect({ to: "/" });
    }
  },
  component: RegisterPage,
});
